export default __webpack_public_path__ + "57f644c6280183e2b5abb689fcfcfbf0.png";